export default __webpack_public_path__ + "static/media/mr-p.e2b07feb.png";